<div class="app-modal-title">New User</div>
<div class="app-modal-content">
	<form #userForm="ngForm">
		<div class="info-line">
			<label>Email</label>
			<input name="user-email" 
			type="email"
			[(ngModel)]="userEmail" 
			placeholder="User Email" 
			required/>
		</div>
		<div class="info-line">
			<label>Role</label>
			<div class="role-group">
				<ng-container *ngFor="let role of roles">
					<label>{{role.desc}}</label>
					<input name="role" type="radio" [(ngModel)]="userRole" [value]="role">
				</ng-container >
			</div>
		</div>
	</form>
</div>
<div class="app-modal-footer">
	<div class="button-group">
		<button class="button-general" md-raised-button (click)="dialogRef.close()">Cancel</button>
		<button class="button-general" md-raised-button (click)="invite()" [disabled]="!userForm.form.valid">Invite</button>
	</div>
</div>
